import { createAction, props } from '@ngrx/store';

import { SwiperInteraction } from './swiper.models';

export const interaction = createAction('[Swiper] Interaction', props<SwiperInteraction>());
